'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getCountryOptions = require('./getCountryOptions');

var phoneOptions = [];

exports.default = function (phoneData) {
  if (phoneOptions.length) {
    return phoneOptions;
  }

  var countryOptions = (0, _getCountryOptions.getCountryOptions)();
  phoneOptions = countryOptions.filter(function (option) {
    return phoneData.find(function (c) {
      return c.iso2 === option.value;
    });
  }).map(function (option) {
    var dialCode = phoneData.find(function (c) {
      return c.iso2 === option.value;
    }).dialCode;
    return _extends({}, option, {
      text: option.text + ' +' + dialCode
    });
  });

  return phoneOptions;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.2379/js/internal/utils/getPhoneOptions.js
// module id = 561
// module chunks = 3 4 5